import { render, staticRenderFns } from "./PaisList.vue?vue&type=template&id=38b28fc4"
import script from "./PaisList.vue?vue&type=script&lang=js"
export * from "./PaisList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports